import { InjectionToken } from '@angular/core';
import { Environment } from '../../models/env-config.model';

export const ENV_CONFIG = new InjectionToken<Environment>('env.config');
